import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { FooterComponent } from '@blocks/footer/footer.component';
import { HeaderComponent } from '@blocks/header/header.component';
import { StatsComponent } from '@blocks/stats/stats.component';
import { filter, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, HeaderComponent, StatsComponent, FooterComponent]
})
export class AppMainLayoutComponent implements OnInit {
  transparentHeader = false;
  isHomePage = false;

  constructor(private readonly router: Router, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        startWith(this.router)
      )
      .subscribe((event: NavigationEnd) => {
        this.isHomePage = event.url === '/home';
        this.transparentHeader = this.isHomePage;
        this.changeDetectorRef.detectChanges();
      });
  }
}
